import React, { Component } from 'react';
import { Container, Row, Button, Col } from 'react-bootstrap';

export default class ProjEditTextareaDom extends React.Component {
    constructor(props) {
        super(props);

        // this.state = {
        //     value: props.value
        // };
        this.onChange = this.onChange.bind(this);
    }

    onChange(event) {
        console.log(event.target.value);
        this.props.onChange(this.props.dataKey, event.target.value);
    }

    render() {
        const { isDisabled, data, value } = this.props;
        // const { value } = this.state;

        if (isDisabled) {
            return (
                <Col className="mb-3">
                    <label>{data.name}</label>
                    <textarea disabled="disabled" className="form-control" rows="4" value={value}></textarea>
                </Col>
            );
        } else {
            return (
                <Col className="mb-3">
                    <label>{data.name}</label>
                    <textarea className="form-control" rows="4" value={value} onChange={this.onChange}></textarea>
                </Col>
            );
        }
    }
}